import { render, staticRenderFns } from "./UserSearchItem.vue?vue&type=template&id=3bc596af&scoped=true"
import script from "./UserSearchItem.vue?vue&type=script&lang=js"
export * from "./UserSearchItem.vue?vue&type=script&lang=js"
import style0 from "./UserSearchItem.vue?vue&type=style&index=0&id=3bc596af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc596af",
  null
  
)

export default component.exports